import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Supported Networks ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Active metamask network is not supported, please change the network to a supported option. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_global_network_icon = _resolveComponent("global-network-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_card = _resolveComponent("n-card")!

  return (_openBlock(), _createBlock(_component_n_card, {
    segmented: {
      footer: 'soft',
      content: true
    },
    role: "modal",
    closable: _ctx.eth.supportedNetworks.includes(_ctx.eth.reactive.value.network.id),
    onClose: _ctx.cancel
  }, _createSlots({
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_n_space, {
        vertical: "",
        style: {"text-align":"center"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.networks, (network, index) => {
            return (_openBlock(), _createBlock(_component_n_button, {
              secondary: "",
              ghost: "",
              block: "",
              strong: "",
              size: "large",
              type: "default",
              color: network.color,
              key: index,
              onClick: ($event: any) => (_ctx.eth.changeNetwork(network)),
              disabled: network.disabled
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_n_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_global_network_icon, {
                      name: network.name
                    }, null, 8, ["name"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(network.capitalizedName()), 1)
              ]),
              _: 2
            }, 1032, ["color", "onClick", "disabled"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (!_ctx.eth.supportedNetworks.includes(_ctx.eth.reactive.value.network.id))
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_component_n_alert, { type: "error" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ])
        }
      : undefined
  ]), 1032, ["closable", "onClose"]))
}